// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchFooter-module_root_1pe5g"};